import { CampaignEntity, AdGroupEntity, AdEntity } from "./buildEntityHierarchy";

export interface InheritedLinkInfo {
  landingPathId?: number;
  smartLinkUrl?: string;
  splitCampaignId?: number;
  inheritedFrom: "direct" | "adGroup" | "campaign" | "none";
}

/**
 * Gets the inherited link for an entity following the hierarchy:
 * - Ad inherits from AdGroup, then Campaign
 * - AdGroup inherits from Campaign
 * - Campaign has no inheritance (top level)
 */
export function getInheritedLink(
  entity: CampaignEntity | AdGroupEntity | AdEntity,
  adGroup?: AdGroupEntity,
  campaign?: CampaignEntity
): InheritedLinkInfo {
  // Check if entity has its own link
  if (entity.currentLandingPathId || entity.currentSmartLinkUrl || entity.currentSplitCampaignId) {
    return {
      landingPathId: entity.currentLandingPathId,
      smartLinkUrl: entity.currentSmartLinkUrl,
      splitCampaignId: entity.currentSplitCampaignId,
      inheritedFrom: "direct",
    };
  }

  // For ads: check adGroup first, then campaign
  if (entity.type === "ad") {
    if (adGroup && (adGroup.currentLandingPathId || adGroup.currentSmartLinkUrl || adGroup.currentSplitCampaignId)) {
      return {
        landingPathId: adGroup.currentLandingPathId,
        smartLinkUrl: adGroup.currentSmartLinkUrl,
        splitCampaignId: adGroup.currentSplitCampaignId,
        inheritedFrom: "adGroup",
      };
    }
    if (campaign && (campaign.currentLandingPathId || campaign.currentSmartLinkUrl || campaign.currentSplitCampaignId)) {
      return {
        landingPathId: campaign.currentLandingPathId,
        smartLinkUrl: campaign.currentSmartLinkUrl,
        splitCampaignId: campaign.currentSplitCampaignId,
        inheritedFrom: "campaign",
      };
    }
  }

  // For adGroups: check campaign
  if (entity.type === "adGroup" && campaign) {
    if (campaign.currentLandingPathId || campaign.currentSmartLinkUrl || campaign.currentSplitCampaignId) {
      return {
        landingPathId: campaign.currentLandingPathId,
        smartLinkUrl: campaign.currentSmartLinkUrl,
        splitCampaignId: campaign.currentSplitCampaignId,
        inheritedFrom: "campaign",
      };
    }
  }

  // No link found
  return {
    inheritedFrom: "none",
  };
}

